{
  "<0>Your <1>{{featureName}}</1> free trial ends <4><0>{{trialEndDate}}</0></4>. Upgrade your plan to include your <6>{{featureName}}</6> subscription now</0>": "<0>Your <1>{{featureName}}</1> free trial ends <4><0>{{trialEndDate}}</0></4>. Upgrade your plan to include your <6>{{featureName}}</6> subscription now</0>",
  "Back": "Back",
  "Get the most out of your trial by configuring your settings and completing our {{featureName}} training courses.": "Get the most out of your trial by configuring your settings and completing our {{featureName}} training courses.",
  "Go to Feature Page": "Go to Feature Page",
  "Manage Subscription": "Manage Subscription",
  "Training Courses": "Training Courses"
}
